import { render, staticRenderFns } from "./SessionsManagement.vue?vue&type=template&id=6ccaacf2&"
import script from "./SessionsManagement.vue?vue&type=script&lang=js&"
export * from "./SessionsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports